import { tour } from '@sloyd/3d';
import { track } from '@sloyd/analytics';
import { selectors } from '@sloyd/store-base';
import { bridge } from '@sloyd/viewer';
import { delay, fork, select, takeEvery } from 'saga-ts';
import { downloadCanvas, invokeEvent, l, recordCanvasVideo, sortBy } from 'shared-base';
import { generatorToModel } from '../utils/models';
import { unityGuard } from './helpers/guards';

export const saga = {
  id: 'sloyd.screenshots',
  type: 'entity',
  root: root,
  trigger: {
    actionTypes: ['SCREENSHOTS'],
  },
};

type Verb =
  | 'allGenerators' //
  | 'allGeneratorsVideo';

type Action = {
  type: 'SCREENSHOTS';
  verb: Verb;
  id: string;
  payload: Json;
  origin?: string;
};

const map: Record<Verb, any> = {
  allGenerators: allGenerators,
  allGeneratorsVideo: allGeneratorsVideo,
};

const analyitcsMapEditor: any = {
  allGenerator: 'All Generator',
  allGeneratorsVideo: 'All Generator video',
};

export function* allGeneratorsVideo(action: Action) {
  try {
    const generators = yield* select(selectors.base.$generators);
    const palettes = yield* select(selectors.base.$palettes);

    generators.sort(sortBy('id'));
    const index = generators.findIndex((g) => g.id === 'G-001');
    // slice, remove first index items
    generators.splice(0, index);
    // sort by id
    generators.sort(sortBy('id'));
    yield tour.prepare(palettes, 1000, 5);

    for (const generator of generators) {
      yield tour.runSingle(generator, () => {
        recordCanvasVideo(5000, `${generator.id}.webm`);
      });

      yield tour.stop();
    }
  } catch (err) {
    console.log('err =>', err);
    invokeEvent('sentry', { err });
  }
}

export function* allGenerators(action: Action) {
  try {
    const generators = yield* select(selectors.base.$generators);
    const palettes = yield* select(selectors.base.$palettes);

    generators.sort(sortBy('id'));
    const index = generators.findIndex((g) => g.id === 'G-001');
    // slice, remove first index items
    generators.splice(0, index);
    // sort by id
    generators.sort(sortBy('id'));

    for (const generator of generators) {
      const model = generatorToModel(generator, palettes);
      bridge.replaceModel(model);
      yield unityGuard();
      yield delay(700);
      downloadCanvas(`${generator.id}.png`);
      yield delay(700);
    }
  } catch (err) {
    console.log('err =>', err);
    invokeEvent('sentry', { err });
  }
}

export function* screenshots(action: Action) {
  const { verb, id, origin } = action;
  yield delay(10);

  const saga = (map as any)[verb];

  if (!saga) {
    return;
  }

  track(analyitcsMapEditor[verb], { origin, id });

  l(`saga|saga.screenshots ${verb} on ${id}`);

  yield* fork(saga, action);
}

export function* root() {
  yield takeEvery('SCREENSHOTS', screenshots);
}
